// @ts-nocheck
import React, {
    useEffect,
    useRef,
    useState
} from 'react';


import {
    URL,
    URL_FRONT
} from '../../service/Service';

import { useI18n } from '../../i18n/I18nContext';

import PaymentMethodIcon from '../PaymentMethodIcon';


const DigitalWallet = ({
                           provider,
                           endpoint,
                           successMethod,
                           value,
                           formReplies,
                           fixedValue,
                           itemPurchases,
                           donations,
                           email,
                           onEmailChange
                       }) => {

    const { language, t } =
        useI18n();


    const iframeRef =
        useRef(null);


    const [isChecked, setIsChecked] =
        useState(false);

    const [isSubmitting, setIsSubmitting] =
        useState(false);

    const [error, setError] =
        useState('');

    const [paymentUrl, setPaymentUrl] =
        useState('');

    const [paymentSucceeded, setPaymentSucceeded] =
        useState(false);


    /*
     * URL pública do frontend.
     */
    const publicFrontendUrl = (
        process.env.REACT_APP_PUBLIC_FRONTEND_URL
        ||
        URL_FRONT
        ||
        window.location.origin
    ).replace(/\/+$/, '');


    /*
     * Origem permitida para postMessage.
     */
    let callbackOrigin = '';

    try {

        callbackOrigin =
            new URL(
                publicFrontendUrl
            ).origin;

    } catch (_error) {

        callbackOrigin = '';

    }


    const paymentErrorMessage =
        `Não foi possível iniciar o pagamento com ${provider}. Tente novamente ou escolha outro método.`;


    const paymentUnavailableMessage =
        `${provider} não está disponível para este formulário. Por favor, selecione outro método de pagamento.`;


    const paymentFailedMessage =
        `O pagamento com ${provider} não foi concluído. Pode tentar novamente ou escolher outro método de pagamento.`;


    /*
     * =====================================================
     * CALLBACK DO IFRAME
     * =====================================================
     */
    useEffect(() => {

        const handleIframeMessage = (event) => {

            /*
             * A mensagem tem de vir exatamente
             * do iframe que estamos a apresentar.
             */
            if (
                iframeRef.current
                &&
                event.source !==
                iframeRef.current.contentWindow
            ) {
                return;
            }


            /*
             * Validar o domínio do callback.
             */
            if (
                callbackOrigin
                &&
                event.origin !== callbackOrigin
            ) {
                return;
            }


            const message =
                event.data;


            if (
                !message
                ||
                message.type !==
                'EUFORMS_PAYMENT_IFRAME'
            ) {
                return;
            }


            if (
                message.formId
                &&
                String(message.formId) !==
                String(formReplies.formID)
            ) {
                return;
            }


            /*
             * =================================================
             * VOLTAR
             * =================================================
             */
            if (message.action === 'back') {

                /*
                 * Fecha o iframe.
                 *
                 * O utilizador volta a ver email,
                 * consentimento e botão do método.
                 */
                setPaymentUrl('');

                setPaymentSucceeded(false);

                setError('');

                setIsSubmitting(false);

                return;
            }


            /*
             * =================================================
             * FALHA / CANCELAMENTO
             * =================================================
             */
            if (message.action === 'fail') {

                setPaymentUrl('');

                setPaymentSucceeded(false);

                setError(
                    paymentFailedMessage
                );

                setIsSubmitting(false);

                return;
            }


            /*
             * =================================================
             * SUCESSO
             * =================================================
             */
            if (message.action === 'success') {

                /*
                 * IT-1220:
                 * o utilizador permanece no formulário.
                 * Fechamos o iframe e apresentamos o sucesso
                 * dentro do próprio card do método de pagamento.
                 */
                setPaymentUrl('');

                setPaymentSucceeded(true);

                setError('');

                setIsSubmitting(false);

                return;
            }

        };


        window.addEventListener(
            'message',
            handleIframeMessage
        );


        return () => {

            window.removeEventListener(
                'message',
                handleIframeMessage
            );

        };

    }, [
        callbackOrigin,
        formReplies.formID,
        paymentFailedMessage
    ]);


    /*
     * Identificar método indisponível.
     */
    const isPaymentMethodUnavailable = (
        responseStatus,
        responseText,
        result
    ) => {

        if (responseStatus === 503) {
            return true;
        }


        const rawMessage = [
            responseText,
            result?.message,
            result?.error,
            result?.detail
        ]
            .filter(Boolean)
            .join(' ')
            .toLowerCase();


        return (
            rawMessage.includes(
                'método de pagamento selecionado não está disponível'
            )
            ||
            rawMessage.includes(
                'metodo de pagamento selecionado nao esta disponivel'
            )
            ||
            rawMessage.includes(
                'método de pagamento não está disponível'
            )
            ||
            rawMessage.includes(
                'metodo de pagamento nao esta disponivel'
            )
            ||
            rawMessage.includes(
                'payment method unavailable'
            )
            ||
            rawMessage.includes(
                'paymentmethodunavailable'
            )
        );
    };


    /*
     * Criar Google Pay / Apple Pay.
     */
    const handlePayment = async () => {

        if (
            isSubmitting
            ||
            !isChecked
        ) {
            return;
        }


        const normalizedEmail =
            String(email || '').trim();


        if (!normalizedEmail) {

            setError(
                'Introduza o seu email.'
            );

            return;
        }


        setIsSubmitting(true);

        setPaymentSucceeded(false);

        setError('');


        const formId =
            encodeURIComponent(
                formReplies.formID
            );


        const encodedMethod =
            encodeURIComponent(
                successMethod
            );


        /*
         * =================================================
         * CALLBACKS
         * =================================================
         */
        const callbackBase =
            `${publicFrontendUrl}/payment-iframe-callback.html`;


        const successUrl =
            `${callbackBase}?action=success&method=${encodedMethod}&formId=${formId}`;


        const failUrl =
            `${callbackBase}?action=fail&method=${encodedMethod}&formId=${formId}`;


        const backUrl =
            `${callbackBase}?action=back&method=${encodedMethod}&formId=${formId}`;


        try {

            const body = {

                value,

                successUrl,

                failUrl,

                backUrl,

                email:
                normalizedEmail,

                fixedValue,

                itemPurchases,

                donations,

                formID:
                formReplies.formID,

                replyFields:
                formReplies.replyFields,

                language,

                ip:
                    formReplies?.ip || ''
            };


            const response =
                await fetch(
                    `${URL}/api/payment/${endpoint}`,
                    {
                        method:
                            'POST',

                        headers: {
                            accept:
                                'application/json',

                            'content-type':
                                'application/json'
                        },

                        body:
                            JSON.stringify(body)
                    }
                );


            const responseText =
                await response.text();


            let result = {};


            if (responseText) {

                try {

                    result =
                        JSON.parse(
                            responseText
                        );

                } catch (_error) {

                    result = {};

                }

            }


            /*
             * Método não disponível.
             */
            if (
                !response.ok
                &&
                isPaymentMethodUnavailable(
                    response.status,
                    responseText,
                    result
                )
            ) {

                setError(
                    paymentUnavailableMessage
                );

                return;
            }


            /*
             * Outro erro.
             */
            if (!response.ok) {

                setError(
                    paymentErrorMessage
                );

                return;
            }


            const redirectUrl =
                result?.redirectUrl
                ||
                result?.urlCc;


            if (!redirectUrl) {

                setError(
                    paymentErrorMessage
                );

                return;
            }


            /*
             * IT-1220:
             *
             * não mudar de página;
             * apresentar dentro do iframe.
             */
            setPaymentUrl(
                redirectUrl
            );


        } catch (_error) {

            setError(
                paymentErrorMessage
            );

        } finally {

            setIsSubmitting(false);

        }

    };


    /*
     * =====================================================
     * SUCESSO DENTRO DO FORMULÁRIO
     * =====================================================
     */
    if (paymentSucceeded) {

        return (

            <div className="mx-auto mt-5 w-full max-w-[460px]">

                <div
                    role="status"
                    aria-live="polite"
                    className="rounded-2xl border p-6 text-center shadow-sm sm:p-8"
                    style={{
                        background: 'var(--form-soft)',
                        borderColor: 'var(--form-border)',
                        color: 'var(--form-text)'
                    }}
                >

                    <div
                        className="mx-auto flex h-16 w-16 items-center justify-center rounded-full border-2"
                        style={{
                            borderColor: 'var(--form-accent)',
                            color: 'var(--form-accent)',
                            background: 'var(--form-surface)'
                        }}
                    >
                        <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="h-9 w-9"
                            aria-hidden="true"
                        >
                            <path d="M20 6 9 17l-5-5" />
                        </svg>
                    </div>

                    <h3
                        className="mt-5 text-xl font-bold sm:text-2xl"
                        style={{
                            color: 'var(--form-text)'
                        }}
                    >
                        O seu pagamento foi processado com sucesso!
                    </h3>

                    <p
                        className="mt-2 text-sm leading-6"
                        style={{
                            color: 'var(--form-muted)'
                        }}
                    >
                        Pagamento concluído com {provider}. Pode permanecer nesta página.
                    </p>

                    <div
                        className="mx-auto mt-5 inline-flex items-center gap-2 rounded-xl border bg-white px-4 py-2"
                        style={{
                            borderColor: 'var(--form-border)'
                        }}
                    >
                        <PaymentMethodIcon
                            method={provider}
                            className="max-h-6 max-w-[48px] w-auto"
                        />

                        <span
                            className="text-sm font-semibold"
                            style={{
                                color: 'var(--form-text)'
                            }}
                        >
                            {provider}
                        </span>
                    </div>

                </div>

            </div>

        );

    }


    /*
     * =====================================================
     * IFRAME
     * =====================================================
     */
    if (paymentUrl) {

        return (

            <div className="mx-auto mt-5 w-full max-w-[460px]">


                {/* CABEÇALHO */}
                <div
                    className="
                        mb-4
                        flex
                        items-start
                        gap-3
                        rounded-2xl
                        border
                        px-4
                        py-4
                        sm:px-5
                    "

                    style={{
                        background:
                            'var(--form-soft)',

                        borderColor:
                            'var(--form-border)',

                        color:
                            'var(--form-text)'
                    }}
                >


                    <div
                        className="
                            flex
                            h-10
                            w-[64px]
                            shrink-0
                            items-center
                            justify-center
                            rounded-xl
                            border
                            bg-white
                            px-2
                            shadow-sm
                        "

                        style={{
                            borderColor:
                                'rgba(0, 0, 0, 0.08)'
                        }}
                    >

                        <PaymentMethodIcon
                            method={provider}

                            className="
                                max-h-6
                                max-w-[48px]
                                w-auto
                            "
                        />

                    </div>


                    <div className="min-w-0">

                        <div
                            className="
                                flex
                                flex-wrap
                                items-center
                                gap-2
                            "
                        >

                            <p
                                className="
                                    text-sm
                                    font-bold
                                    sm:text-base
                                "

                                style={{
                                    color:
                                        'var(--form-text)'
                                }}
                            >
                                {t('Pagamento seguro')}
                            </p>


                            <span
                                className="hidden text-sm sm:inline"

                                style={{
                                    color:
                                        'var(--form-muted)'
                                }}
                            >
                                ·
                            </span>


                            <span
                                className="text-sm font-semibold"

                                style={{
                                    color:
                                        'var(--form-accent)'
                                }}
                            >
                                {provider}
                            </span>

                        </div>


                        <p
                            className="mt-1 text-sm leading-5"

                            style={{
                                color:
                                    'var(--form-muted)'
                            }}
                        >
                            {t('Conclua o pagamento no ambiente seguro da Eupago sem sair do formulário.')}
                        </p>

                    </div>

                </div>


                {/* IFRAME */}
                <div
                    className="
                        mx-auto
                        w-full
                        overflow-hidden
                        rounded-2xl
                        border
                        shadow-sm
                    "

                    style={{
                        maxWidth:
                            '460px',

                        background:
                            '#ffffff',

                        borderColor:
                            'var(--form-border)'
                    }}
                >

                    <iframe
                        ref={iframeRef}

                        src={paymentUrl}

                        title={`${t('Pagamento seguro')} · ${provider}`}

                        allow="payment"

                        className="
                            block
                            w-full
                            border-0
                            bg-white
                        "

                        style={{
                            width:
                                '100%',

                            height:
                                '760px',

                            minHeight:
                                '760px'
                        }}
                    />

                </div>


                {/* SEGURANÇA */}
                <div
                    className="
                        mt-3
                        flex
                        items-center
                        justify-center
                        gap-1.5
                        text-xs
                    "

                    style={{
                        color:
                            'var(--form-muted)'
                    }}
                >

                    <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="h-3.5 w-3.5"
                        aria-hidden="true"
                    >

                        <rect
                            x="5"
                            y="10"
                            width="14"
                            height="10"
                            rx="2"
                        />

                        <path
                            d="M8 10V7a4 4 0 0 1 8 0v3"
                        />

                    </svg>


                    <span>
                        Pagamento processado em ambiente seguro Eupago
                    </span>

                </div>

            </div>

        );

    }


    /*
     * =====================================================
     * ANTES DO PAGAMENTO
     * =====================================================
     */
    return (

        <div className="mt-5">


            {/* MÉTODO */}
            <div
                className="
                    mb-5
                    flex
                    items-center
                    gap-3
                    rounded-2xl
                    border
                    p-4
                "

                style={{
                    background:
                        'var(--form-soft)',

                    borderColor:
                        'var(--form-border)',

                    color:
                        'var(--form-text)'
                }}
            >

                <span
                    className="
                        flex
                        h-12
                        w-[76px]
                        flex-none
                        items-center
                        justify-center
                        rounded-xl
                        border
                        bg-white
                        px-2
                        shadow-sm
                    "

                    style={{
                        borderColor:
                            'rgba(0, 0, 0, 0.08)'
                    }}
                >

                    <PaymentMethodIcon
                        method={provider}

                        className="
                            max-h-8
                            max-w-[60px]
                            w-auto
                        "
                    />

                </span>


                <div className="min-w-0">

                    <p
                        className="font-bold"

                        style={{
                            color:
                                'var(--form-text)'
                        }}
                    >
                        Pagar com {provider}
                    </p>


                    <p
                        className="mt-1 text-sm leading-5"

                        style={{
                            color:
                                'var(--form-muted)'
                        }}
                    >
                        O pagamento será concluído num ambiente seguro da Eupago sem sair deste formulário.
                    </p>

                </div>

            </div>


            {/* EMAIL */}
            <label
                htmlFor={`email-${endpoint}`}
                className="mb-2 block text-sm font-bold"

                style={{
                    color:
                        'var(--form-text)'
                }}
            >
                Email
            </label>


            <input
                id={`email-${endpoint}`}

                type="email"

                name={`email-${endpoint}`}

                autoComplete="email"

                placeholder="Insira o seu Email"

                value={email || ''}

                onChange={onEmailChange}

                disabled={isSubmitting}

                className="
                    block
                    w-full
                    rounded-xl
                    border
                    border-gray-300
                    bg-white
                    p-2.5
                    text-sm
                    text-gray-900
                    outline-none
                    transition
                    focus:border-green-cl
                    focus:ring-2
                    focus:ring-green-cl/20
                    disabled:cursor-not-allowed
                    disabled:opacity-60
                "

                style={{
                    backgroundColor:
                        '#ffffff',

                    color:
                        '#111827'
                }}
            />


            {/* CONSENTIMENTO */}
            <label
                className="
                    mt-6
                    flex
                    cursor-pointer
                    items-start
                    gap-3
                    rounded-xl
                    border
                    p-4
                    text-sm
                "

                style={{
                    color:
                        'var(--form-text)',

                    borderColor:
                        'var(--form-border)',

                    background:
                        'var(--form-surface)'
                }}
            >

                <input
                    type="checkbox"

                    checked={isChecked}

                    disabled={isSubmitting}

                    onChange={(event) => {

                        setIsChecked(
                            event.target.checked
                        );

                        if (error) {
                            setError('');
                        }

                    }}

                    className="
                        mt-0.5
                        h-4
                        w-4
                        shrink-0
                        rounded
                        border-gray-300
                        text-green-cl
                        focus:ring-green-cl
                        disabled:cursor-not-allowed
                        disabled:opacity-60
                    "
                />


                <span className="leading-relaxed">
                    Tomei conhecimento que a informação constante deste formulário é guardada e tratada pela Eupago e dou consentimento para tal.
                </span>

            </label>


            {/* ERRO */}
            {error && (

                <div
                    role="alert"

                    className="
                        mt-4
                        rounded-xl
                        border
                        border-red-200
                        bg-red-50
                        p-4
                    "
                >

                    <p className="text-sm font-semibold text-red-700">
                        {error}
                    </p>

                </div>

            )}


            {/* CONTINUAR */}
            <button
                type="button"

                onClick={handlePayment}

                disabled={
                    !isChecked
                    ||
                    isSubmitting
                    ||
                    !String(email || '').trim()
                }

                className="
                    mt-6
                    inline-flex
                    w-full
                    items-center
                    justify-center
                    rounded-xl
                    bg-green-cl
                    px-5
                    py-3
                    font-semibold
                    text-white
                    transition
                    hover:bg-opacity-90
                    disabled:cursor-not-allowed
                    disabled:opacity-50
                "
            >

                {
                    isSubmitting
                        ? 'A processar...'
                        : `Continuar com ${provider}`
                }

            </button>

        </div>

    );

};


export default DigitalWallet;
